// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zSnaD{display:-webkit-box;display:flex;width:100%;-webkit-box-align:center;align-items:center;color:#f58f63;font-size:12px;line-height:1.3}.KPEEM{margin:0 0 10px}.gBq7t{font-size:14px;line-height:1.83;margin:0 10px 12px;width:auto}.kfsSJ{color:#384041;font-size:12px;margin-bottom:7px;text-align:right}.OVmJc{padding-left:40px}@media screen and (min-width:768px){.zSnaD{line-height:1.83}.y4Jid{left:-1rem;position:relative}.gBq7t{margin:0 0 12px}}.NKIP5{color:#4a4a4a}.ArIDc{-webkit-box-align:start;align-items:start}.Wb2sW{color:#fff}.cQy83{text-align:center;width:auto;-webkit-box-pack:center;justify-content:center}.wnWMj{margin-left:10px;text-align:left}.JiQQp{margin:15px 15px 30px}@media screen and (min-width:768px){.JiQQp{margin-left:30px;margin-right:30px}}.o1ljd{font-size:14px}.ua9XV{margin-bottom:20px}.GXnXO{margin:0 auto;max-width:400px;padding-left:0}.iTzUT{position:absolute;right:0;top:0;width:auto}.OZtlY{color:#e5911a;font-size:.875rem;line-height:1.42}.LK0zE{color:#de443b;font-size:.75rem;line-height:1.5;margin:.25rem 0 .5rem;width:100%}.FNXF8{color:#4a4f51}.zSnaD a{color:inherit}.Jr0dk{flex-shrink:0;margin:0 14px 0 0;fill:none}.vgfUn{color:#747c7f;margin:0 10px 0 0}.b3kQJ{color:#384041;height:20px;margin:0 8px 0 0;width:20px}.IbX3F{height:1rem;margin-right:.5rem;width:1rem}.Jr0dk:only-child{margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `zSnaD`,
	"root_withIcon": `KPEEM`,
	"root_instabook": `gBq7t`,
	"root_instabookCard": `kfsSJ`,
	"root_indent": `OVmJc`,
	"root_outdent": `y4Jid`,
	"root_gray": `NKIP5`,
	"root_alignTop": `ArIDc`,
	"root_white": `Wb2sW`,
	"root_centered": `cQy83`,
	"root_notSendChanges": `wnWMj`,
	"root_tripPanel": `JiQQp`,
	"root_largerFontSize": `o1ljd`,
	"root_largerBottomMargin": `ua9XV`,
	"root_fixedWidth": `GXnXO`,
	"root_event": `iTzUT`,
	"root_inbox": `OZtlY`,
	"root_ctaValidationError": `LK0zE`,
	"root_info": `FNXF8`,
	"icon": `Jr0dk`,
	"icon_instabook": `vgfUn`,
	"icon_instabookCard": `b3kQJ`,
	"icon_ctaValidationError": `IbX3F`
};
module.exports = ___CSS_LOADER_EXPORT___;
